import { render, staticRenderFns } from "./OdooSyncErrorLogModal.vue?vue&type=template&id=7c4a8f44"
import script from "./OdooSyncErrorLogModal.vue?vue&type=script&lang=js"
export * from "./OdooSyncErrorLogModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports